<template>
  <resource-create-wrapper
    :title="item ? $t('resources.sidebars.duplicate_sidebar') : $t('resources.sidebars.new_sidebar')"
    :need-modal="showModal"
    @saveAction="$refs['sidebarForm'].submit()">
    <SidebarForm :sidebar="item" @isDirtyForm="isDirtyForm" ref="sidebarForm"></SidebarForm>
  </resource-create-wrapper>
</template>

<script>
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import SidebarForm from "@/components/forms/SidebarForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceCreateWrapper,
      SidebarForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
      },
      title: {
        type: String,
        required: true,
      },
      /**
       * Item is provided here when duplicating
       */
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
  };
</script>
